import React from 'react';
import { Star } from 'lucide-react';
const HEADSHOT_FALLBACK = 'https://picsum.photos/200/200';
export function Testimonials() {
  const testimonials = [{
    name: 'Sarah M.',
    brokerage: 'Keller Williams Arizona Realty',
    quote: 'Apex saved a $750k listing from sitting on the market. The yard was a disaster. Two days later it looked like a model home.',
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Marcus T.',
    brokerage: 'West USA Realty',
    quote: "I've used Apex on six listings now. They're the only crew I trust to be ready when the photographer shows up.",
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Jenna P.',
    brokerage: 'HomeSmart',
    quote: 'The before and after on my Mesa listing was unreal. We had three offers in a weekend. Worth every dollar.',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&w=200&q=80'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-182">
      <div className="container mx-auto px-4 md:px-6" data-id="element-183">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-184">
          <span className="text-apex-green font-bold text-sm uppercase tracking-[0.2em] block mb-4" data-id="element-185">
            What Realtors Say
          </span>
          <h2 className="text-apex-charcoal font-extrabold text-3xl md:text-5xl tracking-tight" data-id="element-186">
            Trusted By The Top Producers In The Valley.
          </h2>
        </div>

        {/* Mobile: Swipeable flex row. Desktop: Grid */}
        <div className="flex overflow-x-auto md:grid md:grid-cols-3 gap-6 pb-8 md:pb-0 snap-x snap-mandatory hide-scrollbar" data-id="element-187">
          {testimonials.map((testimonial, index) => <div key={index} className="w-[85vw] md:w-auto shrink-0 snap-center bg-apex-light p-8 rounded-md border border-gray-100 flex flex-col" data-id="element-188">
              <div className="flex gap-1 mb-6" data-id="element-189">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-apex-green text-apex-green" data-id="element-190" />)}
              </div>

              <blockquote className="text-apex-charcoal text-lg font-medium leading-relaxed mb-8 flex-grow" data-id="element-191">
                "{testimonial.quote}"
              </blockquote>

              <div className="flex items-center gap-4 mt-auto" data-id="element-192">
                <img src={testimonial.image} alt={testimonial.name} onError={e => {
              ;
              (e.currentTarget as HTMLImageElement).src = HEADSHOT_FALLBACK;
            }} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm bg-gray-200" data-id="element-193" />
                <div data-id="element-194">
                  <div className="font-bold text-apex-charcoal" data-id="element-195">
                    {testimonial.name}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-196">
                    {testimonial.brokerage}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}